
import { computed, defineComponent, PropType, toRefs } from "vue";

export default defineComponent({
  name: "UfEnclosure",
  props: {
    options: {
      type: Object as PropType<Approval.File>,
      default: () => {},
      required: true
    },
    type: {
      type: String,
      default: "number"
    },
    modelValue: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const { modelValue, options } = toRefs(props);
    const disabled = computed(() => options.value.power == 1);
    const licenseFile = computed({
      get() {
        return modelValue.value;
      },
      set(value) {
        emit("update:modelValue", value);
      }
    });
    return {
      licenseFile,
      disabled
    };
  }
});
